// `page` points at the static, crawlable page for that language, where one
// exists. It is what turns this list from sixty labels into sixty links: those
// pages had no inbound link from anywhere in the React app, so Google reached
// them only through the sitemap.
const languages = [
  {
    value: 'albanian',
    label: 'Albanian',
    page: '/languages/albanian-to-english-translation'
  },
  {
    value: 'amharic',
    label: 'Amharic'
  },
  {
    value: 'arabic',
    label: 'Arabic',
    page: '/languages/arabic-to-english-translation'
  },
  {
    value: 'armenian',
    label: 'Armenian',
    page: '/languages/armenian-to-english-translation'
  },
  {
    value: 'bengali',
    label: 'Bengali',
    page: '/languages/bengali-to-english-translation'
  },
  {
    value: 'bosnian',
    label: 'Bosnian',
    page: '/languages/bosnian-to-english-translation'
  },
  {
    value: 'bulgarian',
    label: 'Bulgarian',
    page: '/languages/bulgarian-to-english-translation'
  },
  {
    value: 'burmese',
    label: 'Burmese',
    page: '/languages/burmese-to-english-translation'
  },
  {
    value: 'catalan',
    label: 'Catalan',
    page: '/languages/catalan-to-english-translation'
  },
  {
    value: 'chineseSimp',
    label: 'Chinese (Simplified)',
    page: '/languages/chinese-to-english-translation'
  },
  {
    value: 'chineseTrad',
    label: 'Chinese (Traditional)',
    page: '/languages/chinese-to-english-translation'
  },
  {
    value: 'creole',
    label: 'Creole',
    page: '/languages/haitian-creole-to-english-translation'
  },
  {
    value: 'croatian',
    label: 'Croatian',
    page: '/languages/croatian-to-english-translation'
  },
  {
    value: 'czech',
    label: 'Czech',
    page: '/languages/czech-to-english-translation'
  },
  {
    value: 'danish',
    label: 'Danish',
    page: '/languages/danish-to-english-translation'
  },
  {
    value: 'dari',
    label: 'Dari',
    page: '/languages/persian-to-english-translation'
  },
  {
    value: 'dutch',
    label: 'Dutch',
    page: '/languages/dutch-to-english-translation'
  },
  {
    value: 'english',
    label: 'English'
  },
  {
    value: 'estonian',
    label: 'Estonian'
  },
  {
    value: 'farsi',
    label: 'Farsi',
    page: '/languages/persian-to-english-translation'
  },
  {
    value: 'finnish',
    label: 'Finnish',
    page: '/languages/finnish-to-english-translation'
  },
  {
    value: 'french',
    label: 'French',
    page: '/languages/french-to-english-translation'
  },
  {
    value: 'frenchCan',
    label: 'French (Canadian)',
    page: '/languages/french-to-english-translation'
  },
  {
    value: 'georgian',
    label: 'Georgian',
    page: '/languages/georgian-to-english-translation'
  },
  {
    value: 'german',
    label: 'German',
    page: '/languages/german-to-english-translation'
  },
  {
    value: 'greek',
    label: 'Greek',
    page: '/languages/greek-to-english-translation'
  },
  {
    value: 'gujrati',
    label: 'Gujrati',
    page: '/languages/gujarati-to-english-translation'
  },
  {
    value: 'hausa',
    label: 'Hausa'
  },
  {
    value: 'hebrew',
    label: 'Hebrew',
    page: '/languages/hebrew-to-english-translation'
  },
  {
    value: 'hindi',
    label: 'Hindi',
    page: '/languages/hindi-to-english-translation'
  },
  {
    value: 'hmong',
    label: 'Hmong'
  },
  {
    value: 'hungarian',
    label: 'Hungarian',
    page: '/languages/hungarian-to-english-translation'
  },
  {
    value: 'igbo',
    label: 'Igbo'
  },
  {
    value: 'indonesian',
    label: 'Indonesian',
    page: '/languages/indonesian-to-english-translation'
  },
  {
    value: 'italian',
    label: 'Italian',
    page: '/languages/italian-to-english-translation'
  },
  {
    value: 'japanese',
    label: 'Japanese',
    page: '/languages/japanese-to-english-translation'
  },
  {
    value: 'kannada',
    label: 'Kannada',
    page: '/languages/kannada-to-english-translation'
  },
  {
    value: 'khmer',
    label: 'Khmer'
  },
  {
    value: 'korean',
    label: 'Korean',
    page: '/languages/korean-to-english-translation'
  },
  {
    value: 'kurdish',
    label: 'Kurdish'
  },
  {
    value: 'lao',
    label: 'Lao'
  },
  {
    value: 'latin',
    label: 'Latin',
    page: '/languages/latin-to-english-translation'
  },
  {
    value: 'latvian',
    label: 'Latvian',
    page: '/languages/latvian-to-english-translation'
  },
  {
    value: 'lithuanian',
    label: 'Lithuanian',
    page: '/languages/lithuanian-to-english-translation'
  },
  {
    value: 'macedonian',
    label: 'Macedonian',
    page: '/languages/macedonian-to-english-translation'
  },
  {
    value: 'malay',
    label: 'Malay',
    page: '/languages/malay-to-english-translation'
  },
  {
    value: 'malayalam',
    label: 'Malayalam'
  },
  {
    value: 'maltese',
    label: 'Maltese',
    page: '/languages/maltese-to-english-translation'
  },
  {
    value: 'marathi',
    label: 'Marathi',
    page: '/languages/marathi-to-english-translation'
  },
  {
    value: 'nepali',
    label: 'Nepali',
    page: '/languages/nepali-to-english-translation'
  },
  {
    value: 'norwegian',
    label: 'Norwegian',
    page: '/languages/norwegian-to-english-translation'
  },
  {
    value: 'pashto',
    label: 'Pashto',
    page: '/languages/pashto-to-english-translation'
  },
  {
    value: 'persian',
    label: 'Persian',
    page: '/languages/persian-to-english-translation'
  },
  {
    value: 'polish',
    label: 'Polish',
    page: '/languages/polish-to-english-translation'
  },
  {
    value: 'portugueseBrazil',
    label: 'Portuguese (Brazil)',
    page: '/languages/portuguese-to-english-translation'
  },
  {
    value: 'portuguesePortugal',
    label: 'Portuguese (Portugal)',
    page: '/languages/portuguese-to-english-translation'
  },
  {
    value: 'punjabi',
    label: 'Punjabi',
    page: '/languages/punjabi-to-english-translation'
  },
  {
    value: 'romanian',
    label: 'Romanian',
    page: '/languages/romanian-to-english-translation'
  },
  {
    value: 'russian',
    label: 'Russian',
    page: '/languages/russian-to-english-translation'
  },
  {
    value: 'serbian',
    label: 'Serbian',
    page: '/languages/serbian-to-english-translation'
  },
  {
    value: 'slovak',
    label: 'Slovak',
    page: '/languages/slovak-to-english-translation'
  },
  {
    value: 'slovenian',
    label: 'Slovenian',
    page: '/languages/slovenian-to-english-translation'
  },
  {
    value: 'somali',
    label: 'Somali',
    page: '/languages/somali-to-english-translation'
  },
  {
    value: 'spanish',
    label: 'Spanish',
    page: '/languages/spanish-to-english-translation'
  },
  {
    value: 'swahili',
    label: 'Swahili'
  },
  {
    value: 'swedish',
    label: 'Swedish',
    page: '/languages/swedish-to-english-translation'
  },
  {
    value: 'tagalog',
    label: 'Tagalog',
    page: '/languages/tagalog-to-english-translation'
  },
  {
    value: 'tamil',
    label: 'Tamil',
    page: '/languages/tamil-to-english-translation'
  },
  {
    value: 'telugu',
    label: 'Telugu'
  },
  {
    value: 'thai',
    label: 'Thai',
    page: '/languages/thai-to-english-translation'
  },
  {
    value: 'tigrinya',
    label: 'Tigrinya'
  },
  {
    value: 'turkish',
    label: 'Turkish',
    page: '/languages/turkish-to-english-translation'
  },
  {
    value: 'ukrainian',
    label: 'Ukrainian',
    page: '/languages/ukrainian-to-english-translation'
  },
  {
    value: 'urdu',
    label: 'Urdu',
    page: '/languages/urdu-to-english-translation'
  },
  {
    value: 'uzbek',
    label: 'Uzbek',
    page: '/languages/uzbek-to-english-translation'
  },
  {
    value: 'vietnamese',
    label: 'Vietnamese',
    page: '/languages/vietnamese-to-english-translation'
  },
  {
    value: 'yoruba',
    label: 'Yoruba'
  },
];

// Countries (and other names) a customer may type instead of the language, in
// English and Spanish, so "Angola" finds Portuguese (Portugal) and "Taiwan"
// finds Chinese (Traditional). Only names the language's own name doesn't
// already contain ("Italia" is in "Italian", "Germany" is not in "German").
const ALIASES = {
  albanian: ['Kosovo'],
  amharic: ['Ethiopia', 'Etiopía'],
  arabic: ['Egypt', 'Egipto', 'Morocco', 'Marruecos', 'Saudi Arabia', 'Arabia Saudita', 'Iraq', 'Irak', 'Syria', 'Siria', 'Lebanon', 'Líbano', 'Jordan', 'Jordania', 'Yemen', 'Sudan', 'Sudán', 'Algeria', 'Argelia', 'Tunisia', 'Túnez', 'Libya', 'Libia', 'United Arab Emirates', 'UAE', 'Emiratos', 'Kuwait', 'Qatar', 'Palestine', 'Palestina'],
  bengali: ['Bangladesh', 'Bangla'],
  burmese: ['Myanmar', 'Burma', 'Birmania'],
  chineseSimp: ['China', 'Mainland China', 'Mandarin', 'Mandarín', 'Singapore', 'Singapur'],
  chineseTrad: ['Taiwan', 'Taiwán', 'Hong Kong', 'Macau', 'Macao', 'Cantonese', 'Cantonés', 'Mandarin', 'Mandarín'],
  creole: ['Haiti', 'Haití', 'Haitian', 'Haitiano', 'Kreyòl'],
  croatian: ['Croatia', 'Croacia'],
  czech: ['Czech Republic', 'Czechia', 'Chequia', 'República Checa'],
  danish: ['Denmark', 'Dinamarca'],
  dari: ['Afghanistan', 'Afganistán'],
  dutch: ['Netherlands', 'Holland', 'Países Bajos', 'Holanda', 'Flemish', 'Flamenco', 'Belgium', 'Bélgica', 'Suriname'],
  farsi: ['Iran', 'Irán'],
  finnish: ['Finland', 'Finlandia'],
  french: ['France', 'Francia', 'Belgium', 'Bélgica', 'Switzerland', 'Suiza', 'Haiti', 'Haití', 'Senegal', 'Ivory Coast', "Côte d'Ivoire", 'Costa de Marfil', 'Cameroon', 'Camerún', 'Congo', 'Mali', 'Guinea', 'Morocco', 'Marruecos', 'Algeria', 'Argelia', 'Tunisia', 'Túnez'],
  frenchCan: ['Canada', 'Canadá', 'Quebec', 'Québec'],
  german: ['Germany', 'Alemania', 'Deutsch', 'Austria', 'Switzerland', 'Suiza'],
  greek: ['Greece', 'Grecia', 'Cyprus', 'Chipre'],
  hausa: ['Nigeria', 'Niger'],
  hebrew: ['Israel'],
  hindi: ['India'],
  hungarian: ['Hungary', 'Hungría'],
  igbo: ['Nigeria'],
  khmer: ['Cambodia', 'Camboya'],
  kurdish: ['Kurdistan', 'Kurdistán'],
  lao: ['Laos'],
  malay: ['Malaysia', 'Malasia'],
  maltese: ['Malta'],
  norwegian: ['Norway', 'Noruega'],
  pashto: ['Afghanistan', 'Afganistán', 'Pashtu'],
  persian: ['Iran', 'Irán'],
  polish: ['Poland', 'Polonia'],
  portugueseBrazil: ['Brazil', 'Brasil', 'Brazilian', 'Brasileño', 'Brasileiro'],
  portuguesePortugal: ['European Portuguese', 'Angola', 'Angolan', 'Angoleño', 'Angolano', 'Mozambique', 'Moçambique', 'Cape Verde', 'Cabo Verde', 'Guinea-Bissau', 'Guiné-Bissau', 'São Tomé', 'Santo Tomé', 'Timor-Leste', 'East Timor', 'Timor Oriental', 'Macau', 'Macao'],
  romanian: ['Romania', 'Rumania', 'Moldova', 'Moldavia'],
  slovak: ['Slovakia', 'Eslovaquia'],
  somali: ['Somalia', 'Somaliland'],
  spanish: ['Spain', 'España', 'Castellano', 'Castilian', 'Latin America', 'Latinoamérica', 'Mexico', 'México', 'Argentina', 'Colombia', 'Peru', 'Perú', 'Venezuela', 'Chile', 'Ecuador', 'Guatemala', 'Cuba', 'Bolivia', 'Dominican Republic', 'República Dominicana', 'Honduras', 'Paraguay', 'El Salvador', 'Nicaragua', 'Costa Rica', 'Panama', 'Panamá', 'Puerto Rico', 'Uruguay'],
  swahili: ['Kenya', 'Tanzania', 'Uganda'],
  swedish: ['Sweden', 'Suecia'],
  tagalog: ['Philippines', 'Filipinas', 'Filipino'],
  tamil: ['Sri Lanka'],
  thai: ['Thailand', 'Tailandia'],
  tigrinya: ['Eritrea'],
  turkish: ['Turkey', 'Türkiye', 'Turquía'],
  ukrainian: ['Ukraine', 'Ucrania'],
  urdu: ['Pakistan', 'Pakistán'],
  uzbek: ['Uzbekistan', 'Uzbekistán'],
  yoruba: ['Nigeria'],
};

// A line under the variants whose name alone leaves people unsure which one is
// theirs, shown in the dropdown only. The label itself stays short: invoices,
// the back office and the API show it too.
const HINTS = {
  portuguesePortugal: 'Also Angola, Mozambique, Cabo Verde',
  chineseSimp: 'Mainland China, Singapore',
  chineseTrad: 'Taiwan, Hong Kong, Macau',
};

languages.forEach((language) => {
  if (ALIASES[language.value]) {
    language.aliases = ALIASES[language.value];
  }
  if (HINTS[language.value]) {
    language.hint = HINTS[language.value];
  }
});

export { languages };